<template>
    <div class="home">
      <div class="radio">    
         <van-radio-group v-model="radio" @change="onChange">
                  <van-radio name="0" shape="square" class="rad">接收通知</van-radio>
                  <van-radio name="1" shape="square" class="rad">拒收通知</van-radio>
              </van-radio-group>
  
      </div>
  
    </div>
  </template>
  
  <script>
  import request from '../api/request'
  export default {
    name: 'home',
    data() {
      return {
        radio: '0',code:'',state:''
      }
    },
    components: {
      
    },
  
    mounted() {
      let that=this
      let geturl = window.location.href
    //   var str="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx04ae3e2831a1a047&redirect_uri=https%3A%2F%2Fmp.ytjdv.com%2F%23%2Frecive&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect"
      that.code = geturl.split("code=")[1].split("&")[0]
     //  that.nickName= str.split("nickName=")[1].split("&")[0]
      console.log("code:"+that.code)
      that.state=geturl.split("&state=")[1].split("#")[0]
    //   console.log("state:"+that.state)
    //   return
      if (that.code == '') {
        that.$dialog.alert({
          message: '绑定失败！',
        });
      }else{
        that.loadkaptcha()
      }
    },
    methods:{
      loadkaptcha(){
              let that=this
              request.postOther({code:that.code,uid:that.state},'/wx/home/authMpCode','POST','',res=>{
                  if(res.errno==0){
                      if(res.data.status!=Number(that.radio)) that.radio=res.data.status.toString()
                        that.obj=res.data
                       console.log(res)
                  }
              })
          },
      onChange(e){
        let that=this
        that.obj.status=Number(e)
        console.log(that.obj)
              request.getcommerdata(that.obj,'/wx/home/updateMp','POST','',res=>{
                  if(res.errno==0){
                      // that.radio=res.data.status
                      console.log(res)
                  }
              })
      }
    }
  }
  </script>
  
  <style scoped lang="less">
  .home {
    // .fs;
    height: 100%;
    background-color: #fff;
    overflow: auto;
  }
  .radio{
    display: flex;justify-content: center;align-items: center;height: 100vh;
  }
  .van-radio{
    padding: 20px;
  }
  .rad{
    font-size: 20px;
  }
  </style>
  